import {
  ingestTypeAppend,
  ingestTypeAppendLabel,
  ingestTypeUpdate,
  ingestTypeUpdateLabel,
} from '../../../helpers/ingestSettings.constants';
import {
  allAPIDataSourceTypes,
  allCSVDataSourceTypes,
  allExcelDataSourceTypes,
  allRDBMSTypes,
} from './IncrementalIngestionsSettings.constants';

/**
 * Show Append => Allows the menu item to be shown for CSV's, Excel and API data source types
 * @param {string | undefined} dataSourceTypeId
 * @returns {boolean}
 */
export const showAppend = (dataSourceTypeId = 0) => {
  const isExcel = isExcelType(dataSourceTypeId);
  const isCSV = isCSVType(dataSourceTypeId);
  const isAPI = isApiType(dataSourceTypeId);

  return isCSV || isExcel || isAPI;
};

/**
 * Show Update => Allows the menu item to be shown for RDBMS data source types
 * @param {string | undefined} dataSourceTypeId
 * @returns {boolean}
 */
export const showUpdate = (dataSourceTypeId = 0) => {
  const isRDBMS = isRDBMSDataType(dataSourceTypeId);

  return isRDBMS;
};

/**
 * Utility function that helps us understand whether or not a data source type is RDBMS
 * @param {string | undefined} dataSourceTypeId
 * @return {boolean}
 */
export const isRDBMSDataType = (dataSourceTypeId = null) =>
  allRDBMSTypes.includes(Number(dataSourceTypeId));

/**
 * Utility function that helps us understand whether or not a data source type is CSV
 * @param {string | undefined} dataSourceTypeId
 * @return {boolean}
 */
export const isCSVType = (dataSourceTypeId) =>
  allCSVDataSourceTypes.includes(Number(dataSourceTypeId));

/**
 * Utility function that helps us understand whether or not a data source type is Excel
 * @param {string | undefined} dataSourceTypeId
 * @return {boolean}
 */
export const isExcelType = (dataSourceTypeId) =>
  allExcelDataSourceTypes.includes(Number(dataSourceTypeId));

/**
 * Utility function that helps us understand whether or not a data source type is API
 * @param {string | undefined} dataSourceTypeId
 * @return {boolean}
 */
export const isApiType = (dataSourceTypeId) =>
  allAPIDataSourceTypes.includes(Number(dataSourceTypeId));

/**
 * Utility function that returns the correct right pill option based on the data source type
 * @param {string | undefined} dataSourceTypeId
 * @returns {label: string, value: string}
 */
export const getRightPillOption = (dataSourceTypeId) => {
  return showAppend(dataSourceTypeId)
    ? {
        label: ingestTypeAppendLabel,
        value: ingestTypeAppend,
      }
    : showUpdate(dataSourceTypeId)
      ? {
          label: ingestTypeUpdateLabel,
          value: ingestTypeUpdate,
        }
      : { label: '', value: '' };
};
